<template>
  <div>
    <div class="bottom-option-center-box">
      <div class="bottom-option-center" @click="toggleAutoView" ref="bottomOption">
<!--        <div class="bottom-option-center">-->
        <div class="bottom-option-center-hover"></div>
        <div class="bottom-option-text">
          {{ autoView ? "停止" : "360°环顾" }}
        </div>
      </div>
      <div class="bottom-option-top" @click="goHead"></div>
      <div class="bottom-option-bottom" @click="goPanoBack"></div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import sceneData from "../utils/sceneData";

export default {
  props: {
    krpano: "",
  },
  data() {
    return {
      shareShow: false,
      uiShowOrHide: true,
      autoView: false,
      timeLine: "",
      audio: "",
      musicPlay: true,
      zanNum: "",
      numShow: false,
    };
  },
  methods: {
    ...mapMutations('common', ['SET_CLICKED_MAPLIST']),
    // 前进
    goHead() {
      var sceneIndex = this.krpano.get("scene[get(xml.scene)].index");
      sceneIndex++;
      if (sceneIndex >= this.krpano.get("scene.count")) {
        sceneIndex = 0;
      }
      var newSceneName = this.krpano.get("scene[" + sceneIndex + "].name");
      // 数据插入clickedMapList
      this['SET_CLICKED_MAPLIST'](newSceneName)
      this.krpano.call(
        "loadscene(" +
        newSceneName +
        ",null, MERGE, BLEND(1.0, easeInCubic));"
      );
    },
    // 后退
    goPanoBack() {
      var sceneIndex = this.krpano.get("scene[get(xml.scene)].index");
      sceneIndex--;
      if (sceneIndex < 0) {
        sceneIndex = this.krpano.get("scene.count") - 1;
      }
      var newSceneName = this.krpano.get("scene[" + sceneIndex + "].name");
      // 数据插入clickedMapList
      this['SET_CLICKED_MAPLIST'](newSceneName)
      this.krpano.call(
        "loadscene(" +
        newSceneName +
        ",null, MERGE, BLEND(1.0, easeInCubic));"
      );
    },
    // 点蜡烛
    candleClick() {
      this.$emit("candleClick");
    },



    // 自动巡游
    toggleAutoView() {
      this.autoView = !this.autoView;

      if (this.autoView) {
        this.krpano.set("autorotate.enabled", true);
        this.bombtimer(0);
      } else {
        clearInterval(this.timerLine);
        this.krpano.set("autorotate.enabled", "false");
      }
    },
    bombtimer(timer) {
        var that = this;
        var rotateState = this.krpano.get("autorotate.enabled");
        if (rotateState) {
            this.autoView = true;
            timer++;
            // console.log("循环次数：",timer)
            this.timeLine = setTimeout(function () {
                that.bombtimer(timer);
            }, 1000);

            var rotateSpeed = Math.abs(this.krpano.get("autorotate.speed"));

            var timeAll = 420 / rotateSpeed;

            var nowSceneName = this.krpano.get("xml.scene");
            var sceneShortName = nowSceneName.split("_")[1] + "_" + nowSceneName.split("_")[2];

            if(nowSceneName == "scene_0_1_1"){
                this.krpano.set("autorotate.speed","10");
                timeAll = 51;
            }else if(sceneShortName == "2_5"){
                this.krpano.set("autorotate.speed","-8");
                timeAll = 52;
            }else if(sceneShortName == "2_4"){
                this.krpano.set("autorotate.speed","8");
                timeAll = 52;
            }else if( nowSceneName == "scene_2_2_1" || nowSceneName == "scene_2_2_2" || nowSceneName == "scene_2_2_4" || nowSceneName == "scene_2_2_6" ||
                nowSceneName == "scene_2_10_1" || nowSceneName == "scene_2_14_2" || nowSceneName == "scene_2_14_3" || nowSceneName == "scene_2_14_4" || nowSceneName == "scene_2_14_5" ||
                nowSceneName == "scene_2_14_6" || nowSceneName == "scene_2_14_7" || nowSceneName == "scene_2_14_8" || nowSceneName == "scene_2_14_9" || nowSceneName == "scene_2_14_10" ||
                nowSceneName == "scene_2_15_2" || nowSceneName == "scene_2_15_3" ||
                nowSceneName == "scene_2_17_2" || nowSceneName == "scene_2_17_5" || nowSceneName == "scene_2_17_7" ||
                nowSceneName == "scene_2_32_1" || nowSceneName == "scene_2_32_11" || nowSceneName == "scene_2_32_12"
            ){
                this.krpano.set("autorotate.speed","-8");
                timeAll = 52;
            }else if(nowSceneName == "scene_4_1_1"){
                this.krpano.set("autorotate.speed","0");
                timeAll = 29;
            }else{
                this.krpano.set("autorotate.speed","8");
                timeAll = 52;
            }

            // timeAll += this.krpano.get("autorotate.waittime");
            // console.log("总时间：",timeAll)
            if (timer >= timeAll) {
                timer = 0;
                // console.log("本场景结束了！")
                this.nextscene();
            }
        }
    },
    nextscene() {
      var nowSceneName = this.krpano.get("xml.scene");
      var sceneIndex = this.getIndex(nowSceneName, sceneData);
      sceneIndex++;
      if (sceneIndex >= sceneData.length) {
        sceneIndex = 0;
      }
      this.krpano.call(
        "loadscene(" +
        sceneData[sceneIndex] +
        ",null, MERGE, BLEND(1.0, easeInCubic));"
      );
    },
    getIndex(indexName, nameArr) {
      for (var i = 0; i < nameArr.length; i++) {
        if (indexName === nameArr[i]) {
          return i;
        }
      }
    },
    // 自动巡游end


  },
  mounted() {
    let _this = this;

    document.addEventListener("click", function (e) {
      if (_this.$refs.bottomOption) {
        let isSelf = _this.$refs.bottomOption.contains(e.target)
        if (!isSelf) {
          _this.autoView = false
          _this.timerLine && clearInterval(_this.timerLine);
          _this.krpano.set("autorotate.enabled", "false");
        }
      }
    })




    // document.addEventListener("click", function () {
    //   if (_this.musicPlay && _this.audio.paused) {
    //     _this.audio.play();
    //     sessionStorage.bgmusic = "play";
    //   }
    // });
    // 声音控制end
  },
};
</script>

<style lang="scss" scoped>
@mixin background-com {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}



.bottom-option-center-box {
  width: 244px;
  height: 244px;
  @include background-com();
  // background-image: url("../assets/img/bottom-option-bg.png");
  background-image: url("../assets/img/center-btn/center-btn-bg.png");
  position: absolute;
  bottom: 66px;
  left: 50%;
  margin-left: -122px;
  text-align: center;

  .bottom-option-center {
    width: 100px;
    height: 100px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -50px;
    margin-top: -50px;
    cursor: pointer;
    // background-image: url("../assets/img/option-center-bg.png");
    background-image: url("../assets/img/center-btn/center-btn-anniu.png");
    @include background-com();

    .bottom-option-center-hover {
      width: 100px;
      height: 100px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -50px;
      margin-top: -50px;
      // background-image: url("../assets/img/option-center.png");
      background-image: url("../assets/img/center-btn/center-btn-anniu.png");
      @include background-com();
    }

    &:hover {
      .bottom-option-center-hover {
        display: none;
      }
    }

    .bottom-option-text {
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      width: 100%;
      height: 30px;
      line-height: 30px;
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -15px;
    }
  }

  .bottom-option-top {
    width: 50px;
    height: 28px;
    background-image: url("../assets/img/option-top.png");
    @include background-com();
    position: absolute;
    left: 50%;
    margin-left: -24px;
    top: 30px;
    cursor: pointer;

    &:hover {
      background-image: url("../assets/img/option-top-hover.png");
    }
  }

  .bottom-option-bottom {
    width: 50px;
    height: 28px;
    background-image: url("../assets/img/option-bottom.png");
    @include background-com();
    position: absolute;
    left: 50%;
    margin-left: -24px;
    bottom: 30px;
    cursor: pointer;

    &:hover {
      background-image: url("../assets/img/option-bottom-hover.png");
    }
  }
}

.bottom-item-text {
  text-align: center;
  font-size: 24px;
  color: #aa0000;
  position: absolute;
  bottom: 10p;
  left: 0;
  width: 100%;
  cursor: pointer;
}
</style>
